import React, {useState} from 'react';
import {EmptyContainer} from '../styles';
import Img5 from '../../../assets/images/5.png';
import {config} from '../../../utils/config/config';
import {WorkloadsBody, WorkloadsHeader, WorkloadsHeaderLeft, WorkloadsHeaderTitle} from './styles';
import {
  EmptyCard,
  EmptyImage,
  FluidContainer,
  PowerDropdown,
  WhiteContainer,
  WorkloadTableLeft,
  WorkloadTableRight,
} from '../../../components';

const DefaultSeasons = [
  {title: '2020', value: '2020'},
  {title: '2019', value: '2019'},
  {title: '2018', value: '2018'},
  {title: '2017', value: '2017'},
];

const DefaultEvents = [
  {title: 'Game', value: 'Game'},
  {title: 'Training', value: 'Training'},
  {title: 'Play', value: 'Play'},
];

export default () => {
  const [seasons, useSeasons] = useState<any>(DefaultSeasons[0]);
  const [events, useEvents] = useState<any>(DefaultEvents[0]);

  function HandleSeasons(selectedOption: object | any) {
    useSeasons(selectedOption);
  }

  function HandleEvents(selectedOption: object | any) {
    useEvents(selectedOption);
  }

  return config.blocked ? (
    <EmptyContainer>
      <EmptyCard />
      <EmptyImage src={Img5} />
    </EmptyContainer>
  ) : (
    <FluidContainer>
      <WhiteContainer padding="0 20px">
        <WorkloadsHeader>
          <div>
            <WorkloadsHeaderTitle>SEASON STATS</WorkloadsHeaderTitle>
          </div>
          <WorkloadsHeaderLeft data-cy="workloads-header-left">
            <PowerDropdown
              search={false}
              firstActve={true}
              permaTitle="Season:"
              onClick={HandleSeasons}
              dataArray={DefaultSeasons}
              primaryTitle={seasons.title}
            />
            <PowerDropdown
              search={false}
              firstActve={true}
              permaTitle="Event:"
              onClick={HandleEvents}
              dataArray={DefaultEvents}
              primaryTitle={events.title}
            />
          </WorkloadsHeaderLeft>
        </WorkloadsHeader>
        <WorkloadsBody data-cy="workloads-body-container">
          <WorkloadTableLeft />
          <WorkloadTableRight />
        </WorkloadsBody>
      </WhiteContainer>
    </FluidContainer>
  );
};
